export class StepParameterizationSubscriptionForm {
    incNrId!: number;
    ineBlCabecaChave: boolean = false;
  
    constructor(incNrId: number, ineBlCabecaChave: boolean = false) {
      this.incNrId = incNrId;
      this.ineBlCabecaChave = ineBlCabecaChave;
    }
  
    public static fromParticipant(participant: { incNrId: number; isCabecaChave?: boolean }): StepParameterizationSubscriptionForm {
      return new StepParameterizationSubscriptionForm(participant.incNrId, participant.isCabecaChave ?? false);
    }
  }
  